import React from "react";

function Options() {
  return (
    <div className="container">
      <div
        className="row"
        style={{ justifyContent: "normal", textAlign: "justify" }}
      >
        <div className="border-bottom">
          <h1 className="fs-2" style={{ color: "#000088" }}>
            We Offer
          </h1>
          <p>
            Being a growing firm one of the key features that we look for in our
            candidates is versatility and for this, we have three distinct
            career paths. With our growth we would expect our employees &
            consultants to acquire expertise in their chosen line of a
            profession:
          </p>
          <div className="mt-2">
            <h1 className="fs-4" style={{ color: "#000080" }}>
              Technology stream
            </h1>
            <p>
              Within Technology Stream you may choose to work in the following
              areas:
            </p>
            <ul>
              <li>Industry / service practice strategy / consultancy.</li>
              <li>Technology specialisation.</li>
              <li>System architecture/analysis.</li>
              <li>Business / technical analysis.</li>
              <li>Technology support.</li>
              <li>Designing / developing.</li>
            </ul>
          </div>
          <div className="mt-2">
            <h1 className="fs-4" style={{ color: "#000080" }}>
              Strategy and management stream
            </h1>
            <p>
              Within Strategy and management stream you will have the
              opportunity to migrate from other areas depending upon the need of
              the organisation and your own personal ambition. You will have the
              choice of working in any of the following management areas:
            </p>
            <ul>
              <li>Project management.</li>
              <li>Business development.</li>
              <li>Human resources management.</li>
              <li>Finance development.</li>
            </ul>
          </div>
          <div className="mt-2">
            <h1 className="fs-4" style={{ color: "#000080" }}>
              Processes and research stream
            </h1>
            <p>
              We realize the importance of Processes and Research for any
              organisation and would like to be on track even at the stage of
              our growth. Consciously we provide opportunities in the following
              areas:
            </p>
            <ul>
              <li>Software processes.</li>
              <li>Quality assurance.</li>
              <li>Training.</li>
              <li>Research and development.</li>
              <li>Business / technical analysis.</li>
              <li>Technology support.</li>
              <li>Designing / developing.</li>
            </ul>
          </div>
        </div>
        <div className="mt-3 border-bottom">
          <h1 className="fs-2" style={{ color: "#000080" }}>
            Work For Us
          </h1>
          <p>
            At IT FutureTech Systems, we believe that a job is more than just a
            salary consisting of some figures. The feeling of joining the
            company on the first day or that of meeting new colleagues and
            friends cannot be just described in monetary terms. We’re proud of
            the honest and open environment that allows us to genuinely believe
            that we can support our teams and employees through a healthy work
            and home life balance.
          </p>
          <p>
            The management style is much mature and IT FutureTech than the other
            enterprises of the market. Both of our directors sit on the sales
            floor with consultants and offer them a friendly, direct and
            continuous level of support. We do not measure success purely on
            KPI’s - targets are specifically tailored based on previous personal
            and team achievements.
          </p>
          <p>
            Besides, we invest heavily in the process of training and
            development from your very first day at IT FutureTech systems and
            throughout your career.
          </p>
          <p>
            {" "}
            We pride ourselves on constantly inspiring and motivating our
            employees and are widely appreciated for our generous sales
            incentives.
          </p>
        </div>
        <div className="mt-3">
          <h1 className="fs-2" style={{ color: "#000080" }}>
            Work Culture
          </h1>
          <p>
            As a global organization, we can help you to develop your skill sets
            to the highest potential levels. In our organisation, we have
            different people who have come together as one team, got creative
            and are delivering effective results. We like to learn from each
            other and have fun in this process.
          </p>
          <div className="mt-2">
            <h1 className="fs-4" style={{ color: "#000080" }}>
              Team Spirit
            </h1>
            <p>
              We admire and believe in collaboration. Everyone here works
              together to achieve a common goal in creating better change for
              the stakeholders and clients. We also respect each other’s
              individual qualities and opinions.
            </p>
          </div>
          <div className="mt-2">
            <h1 className="fs-4" style={{ color: "#000080" }}>
              Diversity
            </h1>
            <p>
              Diversity is an integral part of our culture. Not purely because
              we are global and with diverse people working for our organisation
              but also because we encourage it. Ubique is an equal opportunity
              employer and our associates have joined us from several nations
              and they even speak many languages. For us, the concept of
              diversity goes much further and it encompasses many more
              dimensions such as gender, ethnicity, age and lifestyle.
            </p>
            <p>
              At IT FutureTech our people are energetic and full of motivation
              and enthusiasm; we work in a professionally committed manner and
              enjoy our day at work.
            </p>
            <p>
              If you like change and believe in challenging your career in an
              extremely vibrant, stimulating and fun place, IT FutureTech is
              where you should be.
            </p>
            <p>
              We take pride in adhering to the IT FutureTech code of conduct,
              which is in place across the entire Ubique Group. The code is a
              means of upholding and strengthening the trust reposed on us by
              our various stakeholders, be it our customers or the wider
              society.
            </p>
            <p>
              Our senior colleagues follow an open-door policy in which any
              associate can approach the senior management with work-related
              problems.
            </p>
            <p>
              Associates at IT FutureTech can also take part in one-on-one
              sessions where they can interact privately with senior management.
              These sessions are helpful in providing mentorship, as well as
              understanding real-life issues that colleagues face at work. The
              queries and discussions are formally recorded and followed up.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Options;
